import { useNavigate } from "react-router-dom";
import OutOfOffice from "./OutOfOffice"
import { useDispatch, useSelector } from "react-redux";
import { operations } from 'redux/Navigation'
import { CONSTANTS } from "client/utils/constants";
import { useEffect, useState } from "react";
import moment from "moment";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import { getApproversList, setIsOutOfOfficeSaved, saveOutOfOfficeSetting, setApproversList, getCurrentSettings, setCurrentSettings, getValidateBackUpApprover, setValidateBackUpApprover } from "Store/OrderManagement/OutOfOffice/OutOfOfficeActions";
import userProfileSelectors from 'redux/UserProfile/selectors'
import successBee from "../../../../assets/images/SuccessBee.svg";
import rejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import ConfirmationBee from '../../../../assets/images/ConfirmationBee.svg'
import { getIsValidSkipApproval, setIsValidSkipApproval } from "Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyAction";
import { convertToUserTimezone } from "utils";
import permissions, { isAuthorized } from "client/utils/Permissions";


const valuesFields = new Map([
    ['primaryApprover', "Primary Approver"],
    ['backupApprover', "Backup Approver"],
    ['startDate', "Start date"],
    ['endDate', "End date"],
])

const initialPopUpValue = {
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { },
    actionby: "",
    value: 0,
    comments: "",
    hideDialog: () => { }
}

const OutOfOfficeContainer = () => {

    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const navDispatch = operations.dispatchNav(dispatch);
    const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch);

    const {
        approversList,
        userData,
        isOutOfOfficeSaved,
        currentOOOSettings,
        isValidSkipApproval,
        validateBackupApprover
    }: any = useSelector((state: any) => ({
        approversList: state?.OutOfOfficeReducer?.approversList,
        isOutOfOfficeSaved: state?.OutOfOfficeReducer?.isOutOfOfficeSaved,
        currentOOOSettings: state?.OutOfOfficeReducer?.currentOOOSettings,
        userData: userProfileSelectors.getUserDetails(state),
        isValidSkipApproval: state?.ApprovalHierarchyReducers?.isValidSkipApproval,
        validateBackupApprover: state?.OutOfOfficeReducer?.validateBackupApprover
    }))

    const initialValueState = {
        skipApprover: false,
        primaryApprover: '',
        backupApprover: '',
        startDate: null,
        endDate: null
    }

    const [values, setValues] = useState<any>(initialValueState)

    const [errors, setErrors] = useState<any>({})
    const [primaryApproverText, setPrimaryApproverText] = useState<string>("")
    const [secondaryApproverText, setSecondaryApproverText] = useState<string>("")
    const [primaryApproverList, setPrimaryApproverList] = useState<any>([])
    const [secondaryApproverList, setSecondaryApproverList] = useState<any>([])
    const [popupContent, setPopupContent] = useState<any>(initialPopUpValue);
    const debouncedApproverText = useDebounce(primaryApproverText, 500)
    const debouncedSecondaryApproverText = useDebounce(secondaryApproverText, 500)
    const [isCurrentSettingExist, setIsCurrentSettingExist] = useState(false)
    const [currentSettingFromDate, setCurrentSettingFromDate] = useState<any>(null)
    const [clickType, setClickType] = useState<any>(null);

    const pageNavigation = () => {
        if (!isAuthorized(permissions.ViewAdmin) && userData?.emailId) {
            Navigate('/ordermanagement/blank');
        } else {
            dispatch(setApproversList([]))
            navDispatch("Admin");
            dispatchHeaderNav("Admin");
        }
    }
    useEffect(() => {
        pageNavigation()
    }, [])

    useEffect(() => {
        pageNavigation()
    },[userData?.emailId])

    useEffect(()=>{
        if(debouncedApproverText?.length > 2){
            dispatch(getApproversList({
                emailId: debouncedApproverText,
                isPrimaryApprover: true
            }))
        }
    }, [debouncedApproverText])


    useEffect(()=>{
        if(debouncedSecondaryApproverText?.length > 2){
            dispatch(getApproversList({
                emailId: debouncedSecondaryApproverText,
                isPrimaryApprover: false
            }))
        }
    }, [debouncedSecondaryApproverText])

    useEffect(()=>{
        const options = approversList?.response?.map((option: any) => ({...option, label: option?.text}))
        if(approversList?.isPrimaryApprover){
            setPrimaryApproverList(options)
        } else {
            setSecondaryApproverList(options)
        }
        if (currentOOOSettings?.backupApproverEmail) {
            let backupApprover = approversList?.response?.find((approver: any) => approver?.value === currentOOOSettings?.backupApproverEmail)
            setValues({
                ...values,
                backupApprover: values?.skipApprover ? "" : {...backupApprover, label: backupApprover?.text}
            })
            dispatch(setCurrentSettings(null))
        }
    }, [approversList])

    useEffect(() => {
        if (isValidSkipApproval != null) {
            if (isValidSkipApproval) {
                setValues((prev: any) => ({ ...prev, skipApprover: true, backupApprover: "" }))
                setErrors((prev: any) => ({ ...prev, backupApprover: '' }))
            } else {
                setPopupContent({
                    ...initialPopUpValue,
                    title: "INFORMATION",
                    subtextcontent: "Unable to skip the approver.  There must be at least 2 approvers for each cost center",
                    isDialogVisible: true,
                    outlineBtnText: "Ok",
                    isSingleConfirmationBtn: true,
                    titleImg: rejectedBee,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                        setValues((prev: any) => ({ ...prev, skipApprover: false }))
                    },
                    hideDialog: () => hideDialog()
                })
            }
            dispatch(setIsValidSkipApproval(null))
        }
    }, [isValidSkipApproval])

    useEffect(() =>{
        if(validateBackupApprover != null && validateBackupApprover?.page == 'outOfOffice'){
            if(validateBackupApprover?.response?.isValid){
                commonSaveFunction('save')
            } else if(validateBackupApprover?.response?.errorMessage?.length > 0) {
                setPopupContent({
                    ...initialPopUpValue,
                    title: "INFORMATION",
                    subtextcontent: validateBackupApprover?.response?.errorMessage,
                    isDialogVisible: true,
                    outlineBtnText: "Ok",
                    isSingleConfirmationBtn: true,
                    titleImg: ConfirmationBee,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    },
                    hideDialog: () => hideDialog()
                })
            } else{
                setPopupContent({
                    ...initialPopUpValue,
                    title: "INFORMATION",
                    subtextcontent: 'Error occured while validating the approver',
                    isDialogVisible: true,
                    outlineBtnText: "Ok",
                    isSingleConfirmationBtn: true,
                    titleImg: ConfirmationBee,
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    },
                    hideDialog: () => hideDialog()
                })
            }
            dispatch(setValidateBackUpApprover(null))
        }
    },[validateBackupApprover])

    const hideDialog = () => {setPopupContent(initialPopUpValue); dispatch(setIsOutOfOfficeSaved(undefined))}

    useEffect(() => {
        if (typeof isOutOfOfficeSaved === 'boolean') {
            setIsCurrentSettingExist(false)
            if (clickType == 'clear') {
                dispatch(setIsOutOfOfficeSaved(undefined));
                setValues({...values, 
                    skipApprover: false,
                    backupApprover: '',
                    startDate: null,
                    endDate: null})
                setErrors({})
            } else {
                if (isOutOfOfficeSaved) {
                    setPopupContent({
                        ...initialPopUpValue,
                        title: "SAVED",
                        subtextcontent: "Out Of Office Override Saved Successfully",
                        isDialogVisible: true,
                        outlineBtnText: "Ok",
                        isSingleConfirmationBtn: true,
                        titleImg: successBee,
                        popupOutlinebtnOnclick: () => {
                            hideDialog();
                            handleClickBack();
                            dispatch(setIsOutOfOfficeSaved(undefined))
                            dispatch(setCurrentSettings(null))
                        },
                        hideDialog: () => hideDialog()
                    })
                } else {
                    setPopupContent({
                        ...initialPopUpValue,
                        title: "ERROR",
                        subtextcontent: "Erorr Saving Out Of Office Override, Please try again",
                        isDialogVisible: true,
                        outlineBtnText: "Ok",
                        isSingleConfirmationBtn: true,
                        titleImg: rejectedBee,
                        popupOutlinebtnOnclick: () => {
                            hideDialog();
                            dispatch(setIsOutOfOfficeSaved(undefined))
                        },
                        hideDialog: () => hideDialog()
                    })
                }
            }
            setClickType(null)
        }

    }, [isOutOfOfficeSaved])

    useEffect(() => {
        if (currentOOOSettings != null) {
            if (currentOOOSettings?.outOfOfficeSettingId) {
                setCurrentSettingFromDate(new Date(convertToUserTimezone(currentOOOSettings?.fromDate)))
                setIsCurrentSettingExist(true)
                if (currentOOOSettings?.backupApproverEmail) {
                    dispatch(getApproversList({
                        emailId: currentOOOSettings.backupApproverEmail?.split('.')[0],
                        isPrimaryApprover: false
                    }))
                }
                if((currentOOOSettings?.backupApproverEmail == null || currentOOOSettings?.backupApproverEmail?.trim() == "" || currentOOOSettings?.backupApproverEmail == undefined) && currentOOOSettings?.isSkipApproval){
                    setValues({
                        ...values,
                        skipApprover: currentOOOSettings?.isSkipApproval,
                        startDate: new Date(convertToUserTimezone(currentOOOSettings?.fromDate)),
                        endDate: new Date(convertToUserTimezone(currentOOOSettings?.toDate)),
                        outOfOfficeSettingId: currentOOOSettings?.outOfOfficeSettingId,
                        backupApprover: ''
                    })
                }else{
                    setValues({
                        ...values,
                        skipApprover: currentOOOSettings?.isSkipApproval,
                        startDate: new Date(convertToUserTimezone(currentOOOSettings?.fromDate)),
                        endDate: new Date(convertToUserTimezone(currentOOOSettings?.toDate)),
                        outOfOfficeSettingId: currentOOOSettings?.outOfOfficeSettingId
                    })
                }
                setErrors((prev: any) => ({ ...prev, startDate: "", endDate: "", backupApprover: "", primaryApprover: "" }))
            } else {
                setIsCurrentSettingExist(false)
                setCurrentSettingFromDate(null)
                setValues({
                    ...values,
                    skipApprover: false,
                    backupApprover: '',
                    startDate: null,
                    endDate: null})
                setErrors((prev: any) => ({ ...prev, primaryApprover: "", backupApprover: '' }))
            }
            if(currentOOOSettings?.backupApproverEmail == null || currentOOOSettings?.backupApproverEmail?.trim() == "" || currentOOOSettings?.backupApproverEmail == undefined){
                dispatch(setCurrentSettings(null))
            }
        }
    }, [currentOOOSettings])

    
    const handleClickBack = () => {
        Navigate('/ordermanagement'); 
        navDispatch(CONSTANTS.ADMIN); 
        dispatchHeaderNav(CONSTANTS.ADMIN);
        setValues({})
        setErrors({})
        dispatch(setCurrentSettings(null))
    }
    const breadcrumlist = [
        { text: 'Admin Settings', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); handleClickBack() } },
        { text: "Out of Office Override", key: "f2" },
        {}
    ]
        
    const validate = (name: string, value: any) => {
        let isValid = true
        if(!value){
            setErrors((prev: any) => ({...prev, [name]: `Please select ${valuesFields?.get(name)}`}))
            isValid = false
        } else if(name === 'primaryApprover' && values?.backupApprover?.value && value == values?.backupApprover?.value){
            setErrors((prev: any) => ({...prev, [name]: `${valuesFields?.get(name)} cannot be same as ${valuesFields.get('backupApprover')}`}))
            isValid = false
        } else if(name === 'backupApprover' && values?.primaryApprover?.value && value == values?.primaryApprover?.value){
            setErrors((prev: any) => ({...prev, [name]: `${valuesFields?.get(name)} cannot be same as ${valuesFields.get('primaryApprover')}`}))
            isValid = false
        } else if(name === 'startDate' && value && values?.endDate && moment(values?.endDate).isBefore(value)){
            setErrors((prev: any) => ({...prev, [name]: `${valuesFields?.get(name)} cannot be after ${valuesFields?.get('endDate')}`}))
            isValid = false
        } else if(name === 'endDate' && value && values?.startDate && moment(value)?.isBefore(values.startDate)){
            setErrors((prev: any) => ({...prev, [name]: `${valuesFields?.get(name)} cannot be before ${valuesFields?.get('startDate')}`}))
            isValid = false
        } else {
            setErrors((prev: any) => ({...prev, [name]: ''}))
        }
        return isValid
    }

    const validateValues = () => {
        let isValid: boolean[] = []
        for (const value in values) {
            if (value == 'skipApprover') {
                isValid.push(true)
            } else if(values?.skipApprover && value == 'backupApprover'){
                isValid.push(true)
            } else if (value == 'primaryApprover' || value == 'backupApprover') {
                isValid.push(validate(value, values[value]?.value))
            } else {
                isValid.push(validate(value, values[value]))
            }
        }
        return isValid?.every((val: boolean) => val)
    }

    const handleSkipApproverToggleChange = (e: any, value: boolean) => {
        if(value){
            dispatch(getIsValidSkipApproval(values?.primaryApprover?.value))
        }else{
            setValues((prev: any)=> ({...prev, skipApprover: value, backupApprover: value ? "" : prev.backupApprover}))
            setErrors((prev: any) => ({...prev, backupApprover : ''}))
        } 
    }

    const handleChange = (value: any, name: string) => {
        setValues((prev: any) => ({...prev, [name]: value}))
        validate(name, value?.value)
        if(name === 'primaryApprover' && value?.value){
            dispatch(setCurrentSettings(null))
            dispatch(getCurrentSettings(value?.value))
        }
    }

    const handleDateChange = (date: any, name: string) => {
        setValues((prev: any) => ({...prev, [name]: date}))
        validate(name, date)
    }

    const handleCancelClick = () => {
        handleClickBack()
    }

    const commonSaveFunction = (clickType: any) => {
        setClickType(clickType)
        dispatch(setIsOutOfOfficeSaved(undefined))
        let isValidToSubmit = validateValues()
        if(isValidToSubmit || clickType == 'clear'){
            const payload = {
                outOfOfficeSettingId: values?.outOfOfficeSettingId ?? 0,
                primaryApproverEmail: values?.primaryApprover?.value,
                backupApproverEmail: clickType == 'save' ? (values?.skipApprover ? "" : values?.backupApprover?.value) : "",
                fromDate: clickType == 'save' ? moment(values?.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") : moment(currentSettingFromDate).utc().format("YYYY-MM-DDTHH:mm:ss"),
                toDate: clickType == 'save' ? moment(values?.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") : moment().utc().format("YYYY-MM-DDTHH:mm:ss"),
                isSkipApproval: values?.skipApprover,
                savedBy: userData?.emailId,
                isSuperAdminOverride: true
            }
            dispatch(saveOutOfOfficeSetting(payload))
        }
    }

    const handleSaveClick = (e?: any, clickType?: any) => {
       if(clickType == 'clear'){
        setPopupContent({
            ...initialPopUpValue,
            title: "CONFIRMATION",
            subtextcontent: "Are you sure you want to clear the approver settings?",
            isDialogVisible: true,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            isSingleConfirmationBtn: false,
            titleImg: ConfirmationBee,
            popupOutlinebtnOnclick: () => {
                hideDialog();
            },
            popupPrimarybtnOnclick : () => {
                commonSaveFunction('clear')
                hideDialog()
            },
            hideDialog: () => hideDialog()
        })
       }else{
        let isValidToSubmit = validateValues()
        if(isValidToSubmit){
           dispatch(getValidateBackUpApprover({
                backupApproverEmail: values?.backupApprover?.value,
                fromDate: moment(values?.startDate).utc().format("YYYY-MM-DDTHH:mm:ss"),
                toDate: moment(values?.endDate).utc().format("YYYY-MM-DDTHH:mm:ss")
           },"outOfOffice"))
        }
       }
    }

    const searchApprover = (value: any, action: any, name: string) => {
        if (action.action === "input-change") {
            if(name === 'primaryApprover'){
                setPrimaryApproverText(value)
            } else {
                setSecondaryApproverText(value)
            }
        }
      };

    return (
       <OutOfOffice 
            breadcrumlist={breadcrumlist} 
            handleClickBack={handleClickBack} 
            primaryApproverList={primaryApproverList}
            handleSkipApproverToggleChange={handleSkipApproverToggleChange}
            handleChange={handleChange}
            handleDateChange={handleDateChange}
            handleCancelClick={handleCancelClick}
            handleSaveClick={handleSaveClick}
            values={values}
            errors={errors}
            searchApprover={searchApprover}
            popupContent={popupContent}
            secondaryApproverList= {secondaryApproverList}
            isCurrentSettingExist = {isCurrentSettingExist}
            />
    )
}

export default OutOfOfficeContainer